import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function Framework() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
  <iframe
    src={t('framework_pdf')}
    title="PDF Document"
  />
</div>

  );
};

export default Framework;
